(function (ws) {
    'use strict';

    ws.collections.splitOrderCollection = ws.collections.modalTableCollection.extend({

        /**
         * Initialize
         */
        initialize: function () {
            ws.collections.modalTableCollection.prototype.initialize.call(this);
        },

        /**
         * Parsing the response data to template
         * @param {Object} data
         * @returns {Object} data
         */
        parse: function(data) {
            //moving response properties to each model for row template
            _.each(data.rows, function(row) {
                row.multiCurrency = data.multiCurrency;
                row.currency = data.currency;
                row.currencySymbol = data.currencySymbol;
                row.parentVpsCloudProduct = data.vpsCloudProduct;
            });

            if (data.vpsCloudProduct == false) {
                $('.vps-cloud-productheader').hide();
                $('.split-order-cloudProduct-errors').hide();
            }

            return data;
        },

        /**
         * overrides the collection method to match the API request format
         */
        toAPI: function() {

            return _.map(this.getSelectedItems(), function(model) {
                var obj = {};
                obj.qty = model.get('qtyToOrder');
                obj.id = model.get('id');
                obj.vpsCloudProduct = model.get('vpsCloudProduct');
                obj.vrfQuoteNumber = model.get('vrfQuoteNumber');
                obj.vendor = model.get('vendor');
                obj.tangibleProduct = model.get('tangibleProduct');

                return obj;
            });
        }

    });

})(westcon);
